import * as R from 'ramda';


export default function PrioritizeImpactAnalysisDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  bcpDataService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleProcessMove = _handleProcessMove;
  vm.handlePrioritizeImpactAnalysisFormSubmit = _handlePrioritizeImpactAnalysisFormSubmit;
  vm.handleDragStart = _handleDragStart;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _sortProcessesByDays();
    loaderService.showViewLoader = false;
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.prioritizeImpactAnalysisDialog);
  }

  function _sortProcessesByDays() {
    const processGroups = R.map(
      (processGroup) => {
        const sortedProcesses = [];
        const unsortedProcesses = [];

        // Count process groups with only one process as sorted
        if (processGroup.length === 1) {
          sortedProcesses.push(processGroup[0]);
        } else {
          R.forEach(
            (process) => {
              if (process.recoveryPriority) {
                sortedProcesses.push(process);
              } else {
                unsortedProcesses.push(process);
              }
            },
            processGroup
          );
        }

        return {
          sortedProcesses,
          unsortedProcesses,
        };
      },
      R.groupBy(
        process => process.recoveryTimeObjective,
        vm.processes
      )
    );

    vm.processGroups = R.map(
      rto => ({
        recoveryTimeObjective: parseFloat(rto),
        processGroup: processGroups[rto],
      }),
      R.keys(
        processGroups
      )
    );
  }

  function _handleProcessMove(processGroup, process) {
    const unsortedIndex = processGroup.unsortedProcesses.indexOf(process);
    if (unsortedIndex > -1) {
      processGroup.unsortedProcesses.splice(
        unsortedIndex,
        1
      );
    }

    const sortedIndex = processGroup.sortedProcesses.indexOf(process);
    if (sortedIndex > -1) {
      processGroup.sortedProcesses.splice(
        sortedIndex,
        1
      );
    }
  }

  function _handlePrioritizeImpactAnalysisFormSubmit() {
    let prioritizedProcesses = [];
    let isValid = true;

    angular.forEach(
      vm.processGroups,
      (processGroup) => {
        if (processGroup.processGroup.unsortedProcesses.length > 0) {
          isValid = false;
        }
        processGroup.processGroup.sortedProcesses.map((sortedProcess, i) => {
          sortedProcess.recoveryPriority = i + 1;
        });

        prioritizedProcesses = prioritizedProcesses.concat(processGroup.processGroup.sortedProcesses);
      }
    );

    if (isValid) {
      bcpDataService.savePrioritizedProcesses(
        prioritizedProcesses
      ).then(() => {
        alerts.success('The process Impact Analyses have been prioritized successfully.');
        ssDialogService.hide(ssDialogService.dialogs.bcp.prioritizeImpactAnalysisDialog);
        $rootScope.$broadcast('refreshBCPAssessments');
      });
    } else {
      alerts.error('Please prioritize all processes before submitting.');
    }
  }

  function _handleDragStart(event, index) {
    if (index === 0 && event.currentTarget.innerText.includes('Information Technology')) {
      return false;
    }
    return true;
  }
}

PrioritizeImpactAnalysisDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpDataService'
];
